// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"66":"1cbd1c53","255":"be5eea72","335":"a31077a2","382":"bd50b9ee","388":"add441d2","554":"ca8f9191","610":"5f993841","732":"f3aab5c9","810":"a164e2cb","863":"b366d92d","948":"9b7c678f","999":"5d8242a0"}[chunkId] + ".js";
};